export default "__VITE_ASSET__c682fd21__"